import React, { useMemo, useState } from 'react';
import ExpansionContext from './ExpansionContext';

export const ExpansionUUIDProvider = ({ children }) => {
  const [openMap, setOpenMap] = useState<{ [uuid: string]: boolean }>({});
  const expansionContext = useMemo(() => ({ openMap, setOpenMap }), [openMap, setOpenMap]);

  return <ExpansionContext.Provider value={{ ...expansionContext }}>{children}</ExpansionContext.Provider>;
};
